<div class="footer" role="contentinfo">
	<div class="threeColumn templateContainer">
		<div>
			<a class="footerLogo" href="https://my.faa.gov/">
				<span>Dev
					<strong>Kit</strong>
				</span>
			</a>
		</div>
		<div class="twoColumn">
			<div>
				<h2>Sample Footer Title</h2>
				<ul>
					<li>
						<a href="#">Sample Footer Link</a>
					</li>
					<li>
						<a href="#">Sample Footer Link</a>
					</li>
				</ul>
				<h2>Sample Footer Title</h2>
				<ul>
					<li>
						<a href="#">Sample Footer Link</a>
					</li>
					<li>
						<a href="#">Sample Footer Link</a>
					</li>
				</ul>
			</div>
			<div>
				<h2>Sample Footer Title</h2>
				<ul>
					<li>
						<a href="#">Sample Footer Link</a>
					</li>
					<li>
						<a href="#">Sample Footer Link</a>
					</li>
				</ul>
				<h2>Sample Footer Title</h2>
				<ul>
					<li>
						<a href="#">Sample Footer Link</a>
					</li>
					<li>
						<a href="#">Sample Footer Link</a>
					</li>
				</ul>
			</div>
		</div>
		<div class="twoColumn">
			<div>
				<h2>Sample Footer Title</h2>
				<ul>
					<li>
						<a href="#">Sample Footer Link</a>
					</li>
					<li>
						<a href="#">Sample Footer Link</a>
					</li>
				</ul>
				<h2>Sample Footer Title</h2>
				<ul>
					<li>
						<a href="#">Sample Footer Link</a>
					</li>
					<li>
						<a href="#">Sample Footer Link</a>
					</li>
				</ul>
			</div>
			<div>
				<h2>Contact Us</h2>
				<ul>
					<li>
						<a href="https://www.faa.gov/contact/">Contact FAA</a>
					</li>
					<li>
						<a href="https://www.faa.gov/privacy/">Privacy Policy</a>
					</li>
				</ul>
			</div>
		</div>
	</div>
	<div class="faaLink templateContainer">
		<span class="faaBar">
			<a href="https://www.faa.gov/" title="Federal Aviation Administration">
				<span>Federal Aviation Administration</span>
			</a>
		</span>
	</div>
</div>